import { NgModule } from '@angular/core';
import {
    TermsOfUseCheckboxComponent
} from "libraries/component/terms-of-use/terms-of-use-checkbox.component";
import { CommonModule } from "@angular/common";
import { PermissionModule } from "libraries/permission/permission.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { CheckboxFieldModule } from "libraries/module/formbuilder/fields/checkbox-field/checkbox-field.module";

@NgModule({
    imports: [
        CommonModule,
        PermissionModule,
        BtnModule,
        CheckboxFieldModule,
    ],
    exports: [
        TermsOfUseCheckboxComponent
    ],
    declarations: [
        TermsOfUseCheckboxComponent
    ],
    providers: [],
})
export class TermsOfUseModule {
}
